import { z } from "zod";

export const caseTemplateSchema = z.object({
    idUUID: z.string(),
    name: z.string(),
    description: z.string(),
});

export const addCaseTemplateSchema = z.object({
    name: z.string().nonempty({ message: "Name is required" }),
    description: z.string().nonempty({ message: "Description is required" }),
    taskTemplates: z
        .array(
            z.object({
                id: z.string(),
                name: z.string(),
            }),
        )
        .min(1, "Select at least one Task Template"),
});

export const caseTemplateApiSchema = z.object({
    idUUID: z.string().optional().nullable(),
});
